import Dev from './Dev.png';
import Staging from './Staging.png';
import Prod from './Prod.png';
import { ENVIRONMENTS } from '../../../../services/exports/Constants';

function getIcon() {
  switch (import.meta.env.VITE_APP_MODE) {
    case ENVIRONMENTS.DEV:
      return Dev;
    case ENVIRONMENTS.STAGING:
      return Staging;
    default:
      return Prod;
  }
}

export const Favicon = getIcon();
